import Axios from "../api/axios";
import config from "../../config";

const getLetters = () => {
  return Axios.get(`${config.BASE_URL}letters`);
};

export default getLetters;
